var _ = require('lodash');
var $ = require('jquery');
var ImpressService = require('../../services/ImpressService');
var TrackingService = require('../../services/TrackingService');

// shared with demo-preview.js, need to refactor
var images = [
    '8-x-8', 'adobe-analytics', 'asterisk', 'avaya', 'broadsoft', 'cisco', 'desk',
    'freshdesk', 'genesys', 'gmail', 'go-to-meeting', 'google-analytics', 'hubspot',
    'in-house', 'infusionsoft', 'live-chat', 'liveperson', 'marketo',
    'microsoft-dynamics', 'mitel', 'netsuite', 'office-365', 'oracle', 'outlook',
    'panasonic', 'peoplesoft', 'quickbooks', 'right-now', 'salesforce', 'sap-c-4-c',
    'sap-hybris', 'sap', 'service-cloud', 'service-now', 'shoretel', 'siemens', 'skype',
    'sugar-crm', 'webex', 'workday', 'zendesk', 'zoho', 'zoom', 'zopim',
];

var matchTexts = {
    "-regular"      : "has found one matching contact",
    "-multi"        : "has found multiple matching contacts",
    "-none"         : "couldn't find any matching contacts",

    "-out"          : "has found one matching contact",
    "-out-multi"    : "has found multiple matching contacts",
    "-out-none"     : "couldn't find any matching contacts",
}

var stories = {
    inbound : [
        { name: "customer-visits",     text : "Customer visits your website",                              image: null },
        { name: "finds-and-calls",     text : "Finds your phone number and calls you",                     image: null },
        { name: "incoming-call",       text : "Agent receives a call",                                     image: "/images/stories/incoming-call.png" },
        { name: "tenfold-searches",    text : "Tenfold finds all available data across your services",     image: "/images/stories/tenfold-searches.png" },
        { name: "found-matches",       text : "Tenfold {0}",                                               image: null },
    ],
    outbound :  [
        { name: "customer-visits",     text : "Customer requests a contact",                               image: null },
        { name: "finds-and-dials",     text : "Agent finds him in the system and dials his number",        image: "/images/stories/finds-and-dials.png" },
        { name: "outgoing-call",       text : "Customer receives a call from agent",                       image: "/images/stories/outgoing-call.png" },
        { name: "tenfold-searches",    text : "Tenfold finds all available data across your services",     image: "/images/stories/tenfold-searches.png" },
        { name: "found-matches",       text : "Tenfold {0}",                                               image: null },
    ]
};

var siteImages = {
    "Salesforce": "/images/sites/salesforce.png",
    "Microsoft Dynamics": "/images/sites/microsoft-dynamics.png",
    "SugarCRM": "/images/sites/sugar-crm.png",
    "Oracle": "/images/sites/oracle.png",
    "Zoho": "/images/sites/zoho.png",
    "SAP C4C": "/images/sites/c4c.png",
    "ServiceNow": "/images/sites/service-now.png",
    "Zendesk": "/images/sites/zendesk.png",
    "RightNow": "",
    "Service Cloud": "/images/sites/service-cloud.png",
    "Desk": "/images/sites/desk.png",
};

const desktopBackgroundImage = '/images/sites/windows-desktop.png';

var defaultTimeout = 3000;

// for debugging simulated call slides
// var callbacks = [];
// function setTimeout(callback) {
//     callbacks.push(callback);
// }
// window.addEventListener('keyup', function (e) {
//     if (e.keyCode === 78) { // N
//         var t = callbacks.shift();
//         t && t();
//     }
// });

function findSiteImage(services) {
    return services && services.map(s => siteImages[s]).find(x => !!x);
}

module.exports = {
    data : _.wrap({
        timeouts: [],
        activeStory: -1,
        stories: [],
        simulating: false,
        toggleClass: true,
        badgeOpen: false,
        badgeDrag: false
    }),
    props: ['customUrl', 'index', 'floatingUiUrl', 'selectedVerticals', 'presentingRole', 'loggedIn', 'simulateCallData', 'user', 'useDesktopBackground'],
    template: require('./demo.html'),
    watch: {
        simulateCallData: {
            handler: function(data) {
                if (data && data.direction) {
                    this.simulate(data.direction, data.matchType);
                }
            },
            deep: true
        }
    },
    created() {
        ImpressService.onLeave("demo", this.clearTimeouts);

        if (window.DEMO_EVENTS_BOUND) {
            return;
        }

        window.addEventListener('message', event => {
            window.DEMO_EVENTS_BOUND = true;

            const data = event.data;

            if (data && data.name === 'demo-side') {
                $('iframe.floating-badge').each((i, iframe) => {
                    iframe.contentWindow.postMessage(data, '*');
                });
            }

            if (data && data.command === 'forward-to') {
                if (data.message && [data.message.name, data.windowName].includes('demo-side')) {
                    $('iframe.floating-badge').each((i, iframe) => {
                        iframe.contentWindow.postMessage(data.message, '*');
                    });
                }

                if (data.message && [data.message.name, data.windowName].includes('demo-badge')) {
                    $('iframe.floating-main').each((i, iframe) => {
                        iframe.contentWindow.postMessage(data.message, '*');
                    });
                }

                if (data.message && data.windowName === 'all') {
                    $('iframe.floating-main,iframe.floating-badge').each((i, iframe) => {
                        iframe.contentWindow.postMessage(data.message, '*');
                    });
                }
            }

            if (data && data.name === 'demo-badge') {
                if (data.command === 'open-badge') {
                    this.$set(this, 'badgeOpen', true);
                } else if (data.command === 'close-badge') {
                    this.$set(this, 'badgeOpen', false);
                } else if (data.command === 'badge-expand') {
                    this.$set(this, 'toggleClass', false);
                } else {
                    $('iframe.floating-main').each((i, iframe) => {
                        iframe.contentWindow.postMessage(data, '*');
                    });
                }
            }


            if (data && data.command === 'open-transfer') {
                var badgeWindow = $('iframe.inner-badge');
                if (!badgeWindow.hasClass('active')) {
                    return;
                }

                badgeWindow.height(350);
                moveUntilVisible(badgeWindow);
            }

            if (data && data.command === 'close-transfer') {
                $('iframe.inner-badge').height(200);
            }

            if (data && data.command === 'close-sidebar') {
                this.toggle();
            }

            function moveUntilVisible($el) {
                const isVisible = isElementInViewport($el);
                console.log($el, 'is visible? ', isVisible);
                if (!isVisible) {
                    let offset = $el.offset();
                    offset.top = 449;
                    $el.offset(offset);
                }
            }

            function isElementInViewport (el) {
                //special bonus for those using jQuery
                if (typeof jQuery === "function" && el instanceof jQuery) {
                    el = el[0];
                }

                var rect = el.getBoundingClientRect();

                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
                );
            }
        });
    },
    computed: {
        imageUrl() {
            if (this.useDesktopBackground) {
                return desktopBackgroundImage;
            }

            return findSiteImage(this.selectedVerticals[this.presentingRole])
                || findSiteImage(this.selectedVerticals['Sales'])
                || findSiteImage(this.selectedVerticals['Customer Support'])
                || siteImages["Salesforce"];
        },
        // shared with demo-preview.js, need to refactor
        selectedServices() {
            return _(this.selectedVerticals)
                    .values()
                    .flatMap()
                    .uniq()
                    .filter(x => x)
                    .map(_.kebabCase)
                    .intersection(images)
                    .value()
                    .slice(0, 3);
        },
        // shared with demo-preview.js, need to refactor
        selectedSize() {
            return this.selectedServices.length;
        }
    },
    methods: {
        simulate(type, matchType) {
            var time = 0;
            var number = 0;
            this.closeDemo();
            this.clearTimeouts();
            this.stories = stories[type].map(story => this.buildStory(story, matchType));
            this.activeStory = 0;

            if (!this.loggedIn) {
                this.resetBadgeState();
                setTimeout(() => this.simulating = true, 100);
                this.timeouts = stories[type].map(story => {
                    time = time + defaultTimeout;
                    return setTimeout(() => this.activeStory++, time);
                });
            }

            setTimeout(() => this.startCall(matchType), time + 100);

            this.trackSimulateEvent(type, matchType);
        },
        buildStory(story, matchType) {
            return {
                name: story.name,
                image: story.image,
                text : story.text.replace('{0}', matchTexts[matchType || "-regular"])
            };
        },
        startCall(matchType) {
            this.simulating = false;
            this.activeStory = -1;
            $('iframe[name="demo-badge"]').each((i, iframe) => {
                iframe.contentWindow.postMessage('simulate-call' + (matchType || ''), '*');
            });
            //this.openDemo();
        },
        resetBadgeState() {
            this.badgeOpen = false;
            this.badgeDrag = false;
        },
        toggle() {
            this.toggleClass = !this.toggleClass;
        },
        closeDemo() {
            this.toggleClass = true;
        },
        openDemo() {
            this.toggleClass = false;
        },
        clearTimeouts() {
            this.simulating = false;
            this.activeStory = -1;
            this.timeouts.forEach(_.ary(clearTimeout, 1));
            this.timeouts = [];
        },
        trackSimulateEvent(direction, type) {
            if (_.includes(type, 'multi')) {
                type = 'multi-match';
            } else if (_.includes(type, 'no')) {
                type = 'no-match';
            } else {
                type = 'single-match';
            }
            const data = {
                direction,
                type
            };

            if (this.user) {
                data.user = _.get(this.user, 'username');
            }
            TrackingService.trackEvent('simulate-call', data);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/js/components/demo/demo.js
// module id = 94
// module chunks = 0